import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITbCategoryPageFields, ITbPagesMainCategory, ITbPagesMainCategoryFields } from '../shared/interfaces/contentful';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  fields!: ITbPagesMainCategoryFields;

  cards: any;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe((data: any) => {
      const { fields } = data?.content || {};
      this.fields = fields;
      this.cards = fields.cards;
    });
  }
}
